import React, { useEffect, useState } from 'react';
import './EmailVerificationResult.css';
import './App.css'; // Reuse existing styles

function EmailVerificationResult() {
  const [verificationStatus, setVerificationStatus] = useState('loading');
  const [userEmail, setUserEmail] = useState('');

  useEffect(() => {
    // Parse URL parameters to get verification result
    const urlParams = new URLSearchParams(window.location.search);
    const ticket = urlParams.get('ticket');
    const success = urlParams.get('success');
    const email = urlParams.get('email');
    const error = urlParams.get('error');
    const message = urlParams.get('message');

    if (email) {
      setUserEmail(decodeURIComponent(email));
    }

    // Handle Auth0 verification result
    if (ticket) {
      // If we have a ticket, we need to verify it with Auth0
      verifyEmailWithAuth0(ticket);
    } else if (success === 'true') {
      setVerificationStatus('success');
    } else if (error || success === 'false') {
      setVerificationStatus('error');
    } else if (message) {
      // Check if message indicates success or failure
      const lowerMessage = message.toLowerCase();
      if (lowerMessage.includes('verified') || lowerMessage.includes('success')) {
        setVerificationStatus('success');
      } else {
        setVerificationStatus('error');
      }
    } else {
      // Default to success if no clear error
      setVerificationStatus('success');
    }
  }, []);

  const verifyEmailWithAuth0 = async (ticket) => {
    try {
      // Call Auth0's email verification endpoint
      const response = await fetch(`https://${process.env.REACT_APP_AUTH0_DOMAIN}/api/v2/tickets/email-verification/${ticket}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        setVerificationStatus('success');
      } else {
        setVerificationStatus('error');
      }
    } catch (error) {
      console.error('Email verification error:', error);
      setVerificationStatus('error');
    }
  };


  const handleRetry = () => {
    // Redirect to login page to request new verification
    window.location.href = window.location.origin;
  };

  if (verificationStatus === 'loading') {
    return (
      <div className="container">
        <div className="card">
          <img src="/logo.svg" className="logo" alt="Kendall Logo" />
          <div className="spinner"></div>
          <div className="status-text">
            <p>Verifying your email...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="card">
        <img src="/logo.svg" className="logo" alt="Kendall Logo" />
        
        {verificationStatus === 'success' ? (
          <>
            <div className="success-icon">
              <svg className="checkmark" viewBox="0 0 24 24">
                <path d="M9 12l2 2 4-4" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>

            <h2 style={{ color: '#1e212a', fontSize: '1.5rem', fontWeight: '600', marginBottom: '16px', textAlign: 'center' }}>
              Email Verified Successfully!
            </h2>
            
            <div className="success-message">
              <p>Your email address has been verified and your account is now active.</p>
            </div>

            {userEmail && (
              <div className="email-info">
                <p><strong>Verified Email:</strong> {userEmail}</p>
              </div>
            )}

            <p style={{ color: '#65676e', textAlign: 'center', marginBottom: '24px' }}>
              Welcome aboard!
            </p>
          </>
        ) : (
          <>
            <div className="error-icon">
              <svg className="x-mark" viewBox="0 0 24 24">
                <path d="M18 6L6 18M6 6l12 12" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>

            <h2 style={{ color: '#1e212a', fontSize: '1.5rem', fontWeight: '600', marginBottom: '16px', textAlign: 'center' }}>
              Verification Failed
            </h2>
            
            <div className="error-message">
              <p>We couldn't verify your email address. The link may have expired or already been used.</p>
            </div>

            <p style={{ color: '#65676e', textAlign: 'center', marginBottom: '24px' }}>
              Please try requesting a new verification email or contact support if the problem persists.
            </p>

            <button onClick={handleRetry} className="action-button error-button">
              Request New Verification
            </button>
          </>
        )}

        <div className="footer">
          <p>© 2025 Kendall. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
}

export default EmailVerificationResult;
